export const text = {
  PAYMENT_METHODS: 'Payment methods',
  NEW: 'New',
  CLOSE_ADD_CARD: 'Close add card',
  INFO: ' 10 cards max.',
  ERROR: 'Cannot add more than 10 cards.',
}
export const styles = {
  BUTTON_CONTAINER_STYLE: {
    height: 40,
    width: 88,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 5,
  },
  BUTTON_IMAGE_STYLE: { height: 16.5, width: 16.5 },
}
